<template>
  <v-container class="app-container--width-max">
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "TenantsLiabilityMainLayout",
};
</script>

<style scoped></style>
